var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:_vm.classBackground},[_c('div',{staticClass:"card-body text-white"},[_c('div',{staticClass:"d-flex"},[_c('h3',{staticClass:"font-weight-semibold mb-0"},[_vm._v(_vm._s(_vm.value)+" "),(_vm.busy)?_c('i',{staticClass:"icon-spinner2 spinner"}):_vm._e()])]),_c('div',[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }